import React from 'react'
import Response from './Response/index'

export default (props) => (
  <Response type='tradeDone' {...props}>
    Don't trade
  </Response>
)
